import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExpandAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.976 13.59a.75.75 0 0 1 1.06 0L10 16.552l2.964-2.964a.75.75 0 1 1 1.06 1.061l-3.494 3.494a.75.75 0 0 1-1.06 0L5.976 14.65a.75.75 0 0 1 0-1.06m-.001-7.135a.75.75 0 0 1 0-1.06L9.47 1.9a.75.75 0 0 1 1.061 0l3.494 3.494a.75.75 0 1 1-1.06 1.06L10 3.492 7.036 6.455a.75.75 0 0 1-1.06 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExpandAll;
